/* This is the EMIS Re-Entry program for secondary school components */
<template>
	<v-container>
		<div>
			<span v-html="title"></span>
		</div>
		<div>
			<table style="height: 72px;" border="1px;" width="850" cellspacing="0px;">
				<tbody>
					<tr>
						<td style="width: 250px; height: 50px; text-align: center; vertical-align: middle;" rowspan="2">សិស្ស</td>
						<td class="row-header" colspan="2">ថ្នាក់ទី ៧</td>
						<td class="row-header" colspan="2">ថ្នាក់ទី ៨</td>
						<td class="row-header" colspan="2">ថ្នាក់ទី ៩</td>
						<td class="row-header" colspan="2">សរុប</td>
					</tr>
					<tr>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
					</tr>
					<tr v-for="(value, row) in e2.length" :key="row">
						<!-- Input columns -->
						<td class="row-title">{{e2[row]}}</td>
						<td v-for="(value, col) in data[row].dt.length" :key="col" class="row-data">
							<numberinput v-model="data[row].dt[col]" class="number"/>
						</td>
						<!-- Total columns -->
						<td class="row-data">
							<strong>{{row1[row] | blank}}</strong>
						</td>
						<td class="row-data">
							<strong>{{row2[row] | blank}}</strong>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</v-container>
</template>

<script>
import NumberInput from '@/components/common/NumberInput.vue'
import { e2 } from '@/utils/ascf/secConfig.js'
export default {
	props: ["data", "title"],
	components: {
    'numberinput': NumberInput
  },
	data() {
    return {
			e2: e2
    }
	},
	computed: {
    row1: function () {
			let result
			let d = this.data

			result = d.reduce(function (r, a, ind) {
				a.dt.forEach(function (b, i) {
					if(i % 2 === 0) {
						r[ind] = (r[ind] || 0) + Number(b)
					}
				})
				return r
			}, [])
			return result
    },
    row2: function () {
      let result
			let d = this.data

			result = d.reduce(function (r, a, ind) {
				a.dt.forEach(function (b, i) {
					if(i % 2 === 1) {
						r[ind] = (r[ind] || 0) + Number(b)
					}
				})
				return r
			}, [])
			return result
    }
	},
	filters: {
		blank: function (value) {
			if (value==0) return ''
			return value
		}
	}
}
</script>

<style scoped>
  .number {
      width:75px;
      text-align: center;
  }
  .row-data {
    width: 75px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
	.row-title {
    width: 200px;
    height: 25px;
    text-align:left;
    vertical-align: middle;
  }
  .row-header {
    width: 150px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
</style>